<template>
  <el-dialog :visible.sync="dialogShow" class="client-setting-dialog" width="600px" :append-to-body="true" :modal-append-to-body="true" :close-on-click-modal="false">
    <div slot="title" class="font-lg">设置客户</div>
    <div slot="default" class="dialog-body">
      <el-form
        ref="formRef"
        class="form-container"
        :model="formData"
        :rules="rules"
        label-width="100px"
        label-position="left"
      >
        <el-form-item label="客户名称">
          {{ company_name }}
        </el-form-item>
        <el-form-item label="客户等级" prop="customer_level" required>
          <PartnerLevelSelector v-model="formData.customer_level" @change="changeCustomerLevel" />
        </el-form-item>
      </el-form>
    </div>
    <div slot="footer" class="text-center">
      <el-button class="extend" @click="dialogShow = false">取消</el-button>
      <el-button class="extend" type="primary" :disabled="!formData.customer_level" @click="submit">确定</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { updateCustomerApi } from "@/api/prm/prmClientApi";

export default {
  name: "ClientSettingDialog",
  props: {
    show: {
      type: Boolean,
      default: false
    },
    company_name: {
      type: String,
      default: ''
    },
    customer_level: {
      type: [Number, null],
      default: null
    },
    customer_id: {
      type: [Number, null],
      default: null
    }
  },
  components: {
    PartnerLevelSelector: () => import("./PartnerLevelSelector.vue")
  },
  data() {
    return {
      formData: {
        customer_level: null,
        customer_id: null
      },
      rules: {
        customer_level: [
          { required: true, message: " ", trigger: "change" }
        ]
      }
    };
  },
  created() {
    this.formData.customer_level = this.customer_level;
    this.formData.customer_id = this.customer_id;
  },
  computed: {
    dialogShow: {
      get() {
        return this.show;
      },
      set(val) {
        this.$emit("update:show", val);
      }
    }
  },
  methods: {
    changeCustomerLevel(val) {
      this.formData.customer_level = val.value;
    },
    submit() {
      let isValid = true
      this.$refs.formRef.validate(valid => {
        if (!valid) {
          isValid = false
        }
      })
      if (!isValid) return
      const loading = this.$loading({
        lock: true,
        text: "加载中...",
        background: "rgba(0, 0, 0, 0.7)"
      });
      updateCustomerApi(this.formData).then(res => {
        loading.close();
        if (!res.errno) {
          this.$message.success("设置成功");
          this.$emit("success");
          this.dialogShow = false;
        } else {
          this.$message.error(res.message);
        }
      });
    }
  }
};
</script>

<style scoped lang="scss">
.client-setting-dialog {
  .dialog-body {
    height: 300px;

    .form-container {
      width: 440px;
      margin: 0 auto;
    }
  }
}
</style>
